import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		component: both("login"),
	},
	{
		path: '/supplier_register',
		component: both("supplier/register"),
		name: '供应商入驻'
	},
	{
		path: '/',
		component: both("front"),
		children: [
			{
				path: 'index',
				component: both("front/index"),
				name: '首页',
				alias: ''
			},
			{
				path: 'requirement',
				component: both("front/requirement"),
				name: '需求大厅'
			},
			{
				path: 'requirement_info',
				component: both("front/requirement_info"),
				name: '需求大厅详情'
			},
			{
				path: 'search',
				component: both("front/search"),
				name: '搜索'
			},
			{
				path: 'info',
				component: both("front/info"),
				name: '详情'
			},
			{
				path: 'cart',
				component: both("front/cart"),
				name: '购物车'
			},
			{
				path: 'settlement',
				component: both("front/settlement"),
				name: '结算'
			},
			{
				path: 'adjustment',
				component: both("front/adjustment"),
				name: '调整订单'
			},
			{
				path: 'order',
				component: both("front/order"),
				name: '订单'
			},
			{
				path: 'order_info',
				component: both("front/order_info"),
				name: '订单详情'
			},
			{
				path: 'member',
				component: both("front/member/child"),
				children: [
					{
						path: 'index',
						component: both("front/member/index"),
						name: '个人中心'
					},
					{
						path: 'address',
						component: both("front/member/address"),
						name: '地址管理'
					},
					{
						path: 'invoice',
						component: both("front/member/invoice"),
						name: '发票列表'
					},
					{
						path: 'invoice_list',
						component: both("front/member/invoice_list"),
						name: '申请列表'
					},
					{
						path: 'approval',
						component: both("front/member/approval"),
						name: '我的审批'
					},
					{
						path: 'requirement',
						component: both("front/member/requirement"),
						name: '采购需求'
					},
					{
						path: 'requirement_add',
						component: both("front/member/requirement_add"),
						name: '新建采购需求'
					},
					{
						path: 'settlement',
						component: both("front/member/settlement"),
						name: '结算管理'
					},
					{
						path: 'return',
						component: both("front/member/return"),
						name: '售后管理'
					},
					{
						path: 'password',
						component: both("front/member/password"),
						name: '修改密码'
					}
				]
			},
			{
				path: 'approval_info',
				component: both("front/member/approval_info"),
				name: '审批详情'
			},
			{
				path: 'settlement_info',
				component: both("front/member/settlement_info"),
				name: '结算详情'
			},
			{
				path: 'payment',
				component: both("front/payment"),
				name: '支付'
			}
		],
	},
	{
		path: '/system',
		component: both("Home"),
		children: [
			{
				path: '',
				component: both("system/index"),
				name: '后台首页'
			}
		],
	},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js